import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { CurrenciesItem } from './CurrenciesItem'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { getAccountCurrenciesAsync, resetSelectedRecordObjectInState, getCurrentBaseCurrenyAsync, DeleteSelectedAccountCurrencyAsync,
    getAccountBaseCurrencyIdAsync,updatePagination} from './CurrenciesSlice'
import { CurrenciesForm } from './CurrenciesForm'
import fetchAPI from '../../../common/fetchAPI'
import { BaseCurrencyForm } from '../baseCurrencies/BaseCurrencyForm'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import OffCanvas from '../../../common/OffCanvas';
import { useTranslation } from 'react-i18next'
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle'
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';



const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

export const Currencies = () => {

    const dispatch = useAppDispatch();
    const {AccountBaseCurrencyId, CurrenciesList, isReload,isLoading, BaseCurrency,sortOrder, sortColumn, search, pageNo, pageSize, selectedRecord } = useAppSelector((state) => state.currencies);
    const { t } = useTranslation();
    const [CurrenciesArray, SetCurrenciesArray] = useState<any | ''>([]);
    const [BaseCurrencyArray, SetBaseCurrencyArray] = useState<any | ''>([]);
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const location = useLocation();
    const navigate = useNavigate();

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    // const filteredData = CurrenciesList.filter((item: any) => {
    //     const searchTermLowerCase = searchTerm.toLowerCase();
    //     return Object.values(item).some((value: any) => {
    //         if (typeof value === 'string') {
    //             return value.toLowerCase().includes(searchTermLowerCase);
    //         }
    //         else if (typeof value === 'number') {
    //             return value.toString().includes(searchTermLowerCase);
    //         }
    //         return false;
    //     });
    // });
    // const filteredData = getFilteredList(CurrenciesList,searchTerm)
    // const filteredData = CurrenciesList.filter((item: any) => {
    //     const searchTermLowerCase = searchTerm.toLowerCase();
    //     return Object.values(item).some((value: any) => {
    //         if (typeof value === 'string') {
    //             // Check if value is a date string
    //             if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/)) {
    //                 // Convert date string to Date object
    //                 const dateValue = new Date(value);
    //                 // Check if date is valid
    //                 if (!isNaN(dateValue.getTime())) {
    //                     // Format date as needed for comparison
    //                     const formattedDate = dateValue.toLocaleDateString('en-US', {
    //                         year: 'numeric',
    //                         month: 'numeric', // Use 'numeric' for 1-digit month
    //                         day: 'numeric', // Use 'numeric' for 1-digit day
    //                         // year: 'numeric',
    //                         // month: '2-digit',
    //                         // day: '2-digit',
    //                     });
    //                     return formattedDate.toLowerCase().includes(searchTermLowerCase);
    //                 }
    //             } else {
    //                 // Preprocess the search term for date values without leading zeros
    //                 const processedSearchTerm = value.toLowerCase().replace(/\b(\d{1})\/(\d{1,2})\/(\d{4})\b/g, '0$1/$2/$3');
    //                 return processedSearchTerm.includes(searchTermLowerCase);
    //             }
    //         } else if (typeof value === 'number') {
    //             return value.toString().includes(searchTermLowerCase);
    //         }
    //         return false;
    //     });
    // });

    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = CurrenciesList.length;
    // const recordsFiltered = (totalItems === filteredData.length ? 0 : currentItems.length);

    const filteredData: any = getFilteredList(CurrenciesList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = CurrenciesList.length;
    const recordsFiltered = filteredData.length;

    const [modals, setModals] = useState<{ [key: string]: boolean }>({
        currenciesFormModal: false,
        baseCurrencyFormModal: false,
    });
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];

    const toggleModal = (key: string) => {
        const updatedModals = Object.keys(modals).reduce((acc: { [key: string]: boolean }, modalKey: string) => {
            acc[modalKey] = modalKey === key ? !modals[modalKey] : false;
            return acc;
        }, {});

        setModals(updatedModals);
    };


    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };
    
    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    useEffect(() => {
        if (isReload) {
            dispatch(getAccountCurrenciesAsync());
        }
    }, [isReload]
    )

    useEffect(() => {
        dispatch(getAccountCurrenciesAsync());
        getCurrenciesForDropDownAsync();
    }, [dispatch])

    useEffect(() => {
        if (isReload) {
            dispatch(getCurrentBaseCurrenyAsync());
            dispatch(getAccountBaseCurrencyIdAsync())
            .then(result => {                
                const nAccountBaseCurrencyId: any = result.payload.Data[0].AccountBaseCurrencyId;
                getvueAccountCurrencyByAccountIdAndDisabledAsync1(nAccountBaseCurrencyId);
            });
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getCurrentBaseCurrenyAsync());
        dispatch(getAccountBaseCurrencyIdAsync())
            .then(result => {                
                const nAccountBaseCurrencyId: any = result.payload.Data[0].AccountBaseCurrencyId;
                getvueAccountCurrencyByAccountIdAndDisabledAsync1(nAccountBaseCurrencyId);
            });
    }, [dispatch])

    const getCurrenciesForDropDownAsync = async () => {
        const response = await fetchAPI("api/v2/Currencies/CurrenciesWithCode", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.CurrencyId;
            item.label = item.CurrencyWithCode;
            delete item.CurrencyId;
            delete item.CurrencyWithCode;
        });
        SetCurrenciesArray(json.Data);
    }
   
    const getvueAccountCurrencyByAccountIdAndDisabledAsync1 = async (nAccountBaseCurrencyId: any) => {
        const response = await fetchAPI("api/v2/Currencies/CurrencyDisabled/" + nAccountBaseCurrencyId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.Currency;
        });
        SetBaseCurrencyArray(json.Data);
        const foundOption: any = json.Data.find((option: { AccountCurrencyId: any; }) => option.AccountCurrencyId === nAccountBaseCurrencyId);
        if (foundOption !== undefined) {
            setSelectedOptionDropDown({ value: foundOption.value, label: foundOption.label });
        }
    }

    const handleOnClickEvent = (modalKey:string) => {
        dispatch(resetSelectedRecordObjectInState());
        toggleModal(modalKey);
    }

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountCurrencyAsync(CurrenciesList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Currencies delete Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");                            
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {                
            });

    }

    const isModalOpen = (modalKey : string) => {
        return modals[modalKey];
      };

      const isModalClosed = (modalKey : string) => {
        return !modals[modalKey];
      };

    return (
        <>
               {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1"  >
                        {/* {t('Currencies')} */}
                        {getValueFromResource('Currencies', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-description"
                            data-tooltip-content={getValueFromResource('Manage the list of available currencies used in the system for billing, invoicing, expenses, and financial calculations.', dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="d-flex align-items-center flex-wrap">
                            <div
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content=
                                // {t("Current Base Currency")}
                                {getValueFromResource('Current Base Currency',dispatch, t)}
                                data-tooltip-place="bottom"
                                style={{marginRight:'5px'}}
                            >
                                <span className='badge badge-light-success fs-7 fw-semibold'>{BaseCurrency}</span>
                            </div>
                            
                            {IsEdit &&
                                <>

                                    <a
                                        className={`btn btn-icon btn-active-light-dark btn-sm ms-0`}
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("Change Base Currency")}
                                        {getValueFromResource('Change Base Currency',dispatch, t)}
                                        data-tooltip-place="bottom"
                                        onClick={() => handleOnClickEvent('baseCurrencyFormModal')}
                                    >
                                        <i className={`bi bi-cash fs-3 iconColor`}></i>
                                    </a>
                            {/* &nbsp;
                            <div
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content={t("Change Base Currency")}
                                data-tooltip-place="bottom"
                            >
                                <i className="bi bi-cash fs-5 custom-pointer-cursor " onClick={() => handleOnClickEvent('baseCurrencyFormModal')}></i>
                            </div> */}
                            </>
                            }
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                             <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>


                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}
                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}


                        {(IsAdd || (IsDelete && CurrenciesList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ):null
                        }
                        
                        {IsAdd &&
                            <button 
                                //ref={modelRef} 
                                type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={()=>handleOnClickEvent('currenciesFormModal')}
                                style={{ marginRight: '2px', display: CurrenciesList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Currency')} */}
                                {getValueFromResource('Add Currency',dispatch, t)}

                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: CurrenciesList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{CurrenciesList.filter((item: any) => item.isSelected === 1).length}</span>
                                     {/* {t('Selected')} */}
                                     {getValueFromResource('Selected',dispatch, t)}

                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: CurrenciesList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                {/* <div className="card-body"> */}
                   <div className="card-Report-body">
                    <div className="table-responsive">
                        <CurrenciesItem 
                        CurrenciesList={currentItems} 
                        onToggleModal={() => toggleModal('currenciesFormModal')} 
                        AccountBaseCurrencyId={AccountBaseCurrencyId} 
                        t={t} 
                        IsEdit={IsEdit} 
                        IsDelete={IsDelete} 
                        />
                    </div>
                </div>
            </div>

            {isModalOpen('currenciesFormModal') && 
                <CurrenciesForm  t={t} onToggleModal={() => toggleModal('currenciesFormModal')} CurrenciesArray={CurrenciesArray} />
            }
            {isModalOpen('baseCurrencyFormModal') && 
                <BaseCurrencyForm t={t} onToggleModal={() => toggleModal('baseCurrencyFormModal')} BaseCurrencyArray={BaseCurrencyArray} selectedOptionDropDown={selectedOptionDropDown} />
            }
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="bottom"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
            
        </>
    )
}